import i18n, { type Resource } from "i18next";
import ICU from "i18next-icu";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { buildFallbackMap } from "./language-utils";
import { NormalizingDetector, loadSupportedLanguages } from "./i18n-helpers";

export { i18n };

const DEFAULT_I18N_BASE_URL = "https://i18n.baback.co";
const DEFAULT_I18N_NAMESPACES = ["trackoffice"];

export default function initTranslationsICU(
  base = import.meta.env.VITE_I18N_BASE_URL ?? DEFAULT_I18N_BASE_URL,
  namespaces = DEFAULT_I18N_NAMESPACES,
  onMissingKey?: (key: string, lngs: readonly string[]) => void,
  bundledResources?: Resource,
) {
  i18n
    .use(ICU)
    .use(HttpBackend)
    .use(NormalizingDetector)
    .use(initReactI18next);

  return loadSupportedLanguages(base, namespaces[0]).then((supportedLngs) =>
    i18n.init({
      fallbackLng: buildFallbackMap(supportedLngs),
      supportedLngs,
      ns: namespaces,
      defaultNS: namespaces[0],
      resources: bundledResources,
      partialBundledLanguages: bundledResources !== undefined,
      backend: {
        loadPath: `${base}/{{ns}}/{{lng}}.json`,
      },
      interpolation: {
        escapeValue: false,
      },
      saveMissing: true,
      missingKeyHandler: (lngs, _ns, key) => {
        console.warn(`[i18n] Missing translation key "${key}" for: ${lngs.join(", ")}`);
        onMissingKey?.(key, lngs);
      },
      react: {
        useSuspense: true,
      },
    }),
  );
}
